import { ChartView } from 'src/Libs/chart-kit/shared/utils/chartModel'
import { DatePickerView, DateTimePickerView } from '../types'

/**
 * get view array for date picker
 */
export const getDateViews = (view: ChartView): DatePickerView[] => {
  switch (view) {
    case 'year':
      return ['year']
    case 'month':
      return ['year', 'month']
    case 'week':
    case 'day':
    default:
      return ['year', 'month', 'day']
  }
}

/**
 * get view array for date range picker
 */
export const getDateRangeViews = (view: ChartView): DateTimePickerView[] => {
  switch (view) {
    case 'year':
      return ['year', 'month']
    case 'month':
    case 'week':
      return ['year', 'month', 'day']
    case 'day':
    default:
      return ['year', 'month', 'day']
  }
}

/**
 * get openTo value for datepicker
 */
export const getOpenToValue = (view: ChartView): DatePickerView => {
  switch (view) {
    case 'year':
      return 'year'
    case 'month':
      return 'month'
    case 'week':
    case 'day':
    default:
      return 'day'
  }
}

/**
 * get openTo value for datepicker
 */
export const getOpenToRangeValue = (view: ChartView): DateTimePickerView => {
  switch (view) {
    case 'year':
      return 'month'
    case 'month':
    case 'week':
    case 'day':
    default:
      return 'day'
  }
}
